import { Control, Controller } from 'react-hook-form';

import { languages, LANGUAGE_MAP } from '@data';
import { ToggleButtonCard, Stack, Text, u } from '@ui';

import { UserWelcomeWizardForm } from '../useUserWelcomeWizard';

import { optionGrid } from './CommonStyles.css';

type LanguageStepProps = {
    control: Control<UserWelcomeWizardForm>;
};

export const LanguageStep = ({ control }: LanguageStepProps) => {
    return (
        <Controller
            control={control}
            name="locale"
            render={({ field }) => (
                <div className={optionGrid}>
                    {languages.map((locale) => (
                        <ToggleButtonCard
                            key={locale}
                            value={locale}
                            onClick={field.onChange}
                            isSelected={field.value === locale}
                        >
                            <Stack gap={u(1)} alignItems="flex-start">
                                <Text variant="h3" color="inherit">
                                    {LANGUAGE_MAP[locale]}
                                </Text>
                                <Text variant="pSmall" color="inherit">
                                    {locale.toUpperCase()}
                                </Text>
                            </Stack>
                        </ToggleButtonCard>
                    ))}
                </div>
            )}
        />
    );
};
